/* eRamis - bara de praguri din sertarul de cos (referinta: alcanside.com).
   snippets/eramis-cart-drawer.liquid are 15,5 KB, peste pragul de transfer, deci NU
   il rescriem: ascundem bara lui simpla si punem una noua peste, in acelasi #erShippingBar.
   Elementele originale (#erShippingText, #erShippingProgress) RAMAN in pagina, doar
   ascunse - codul sertarului continua sa scrie in ele fara sa crape, iar noi ne folosim
   de scrisul ala ca semnal ca s-a re-randat cosul.

   MECANICA masurata la referinta: pragurile sunt la distante EGALE pe bara (cu doua
   praguri: 50% si 100%), nu proportional cu suma. Umplerea avanseaza proportional in
   interiorul segmentului curent. La 313 din 400 lei, umplerea era la 39% - adica 78%
   din primul segment de 50%. */
(function(){
  'use strict';

  /* ── PRAGURILE ──────────────────────────────────────────────────────────────
     Sumele sunt in BANI (25000 = 250,00 lei).

     ATENTIE 1: primul prag TREBUIE sa fie acelasi cu FREE_SHIPPING din
     snippets/eramis-cart-drawer.liquid (acum 25000) SI cu ce e in Settings -> Shipping.
     Daca difera, clientul vede doua cifre diferite pentru aceeasi promisiune.

     ATENTIE 2: al doilea prag e PUS DE MINE ca exemplu, ca sa vezi bara cu doua trepte.
     Nu stiu ce cadou oferi si de la ce suma. Schimba-l sau sterge randul - cu un singur
     prag bara functioneaza la fel, doar ca punctul unic sta la capat. */
  var PRAGURI = [
    { bani: 25000, eticheta: 'Livrare gratuită' },
    { bani: 40000, eticheta: 'Cadou surpriză' }
  ];

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function lei(bani){ return (bani/100).toFixed(2).replace('.', ',') + ' lei'; }

  function stiluri(){
    if(document.getElementById('ersb-style')){ return; }
    var css = [
      '#erShippingBar .erc-ship-row,#erShippingBar .erc-ship-track{display:none!important}',
      '.ersb{padding:2px 0 0}',
      '.ersb-text{text-align:center;font-size:13px;line-height:1.4;color:#5b4a54;margin:0 0 15px}',
      '.ersb-text strong{color:#3D1F3D;font-weight:600}',
      /* Verdele si grisul sunt luate de la referinta, nu din paleta eRamis: verdele e
         conventia universala pentru progres si se citeste instant ca "mai ai putin".
         Daca vrei sa revii la auriul magazinului: #E8B547 la fill, #e3d8c8 la track. */
      '.ersb-track{position:relative;height:5px;background:#e7e7e7;border-radius:5px;margin:0 10px}',
      '.ersb-fill{position:absolute;top:0;bottom:0;left:0;width:0;background:#A8E6A1;border-radius:5px;transition:width .45s ease}',
      '.ersb-dot{position:absolute;top:50%;width:20px;height:20px;margin:-10px 0 0 -10px;border-radius:50%;',
      'background:#d6d6d6;color:#fff;display:flex;align-items:center;justify-content:center;transition:background .3s ease}',
      '.ersb-dot.is-on{background:#6FC96A}',
      /* Bifa apare DOAR la pragul atins. Inainte era mereu randata (alb pe gri) si
         clientul citea doua bife ca "deblocat", chiar daca nu ajunsese la niciun prag. */
      '.ersb-dot svg{width:11px;height:11px;display:none}',
      '.ersb-dot.is-on svg{display:block}',
      '.ersb-labels{position:relative;height:32px;margin:0 10px}',
      '.ersb-lab{position:absolute;top:9px;transform:translateX(-50%);text-align:center;white-space:nowrap}',
      '.ersb-lab:last-child{transform:translateX(-100%);text-align:right}',
      '.ersb-lab b{display:block;font-size:12px;font-weight:600;color:#3D1F3D;line-height:1.2}',
      '.ersb-lab span{display:block;font-size:10.5px;color:#9a8b95;line-height:1.3}',
      '@media (prefers-reduced-motion:reduce){.ersb-fill{transition:none}}',
      /* ── CORECTII PE SERTAR ──────────────────────────────────────────────────
         Locul lor e snippets/eramis-cart-drawer.liquid, dar acela are 15,5 KB, peste
         limita de scriere prin API - se poate doar citi. DACA STERGI bara de praguri,
         MUTA-LE, altfel sertarul intra iar sub header si X-ul revine la forma veche.
         z-index: header-ul fixat (9990) acoperea capul sertarului (310), adica exact
         butonul de iesire. X: negru, colturi 14px; !important bate regula globala de
         colturi drepte pe <button>. #1C1410 e negrul paletei; pentru negru pur, #000. */
      '#erCartOverlay{z-index:9995!important}',
      '#erCartDrawer{z-index:9996!important}',
      '#erCartDrawer .erc-close{background:#1C1410!important;color:#fff!important;border-radius:14px!important}',
      '#erCartDrawer .erc-close:hover{background:#000!important}'
    ].join('');
    var el = document.createElement('style');
    el.id = 'ersb-style';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function schelet(bar){
    var n = PRAGURI.length;
    var seg = 100 / n;
    var puncte = '', etichete = '';
    PRAGURI.forEach(function(p, i){
      var la = seg * (i + 1);
      puncte += '<span class="ersb-dot" data-i="' + i + '" style="left:' + la + '%">' + CHECK + '</span>';
      etichete += '<span class="ersb-lab" style="left:' + la + '%"><b>' + lei(p.bani).replace(',00', '') +
                  '</b><span>' + p.eticheta + '</span></span>';
    });
    var box = document.createElement('div');
    box.className = 'ersb';
    box.innerHTML = '<p class="ersb-text" id="ersbText"></p>' +
                    '<div class="ersb-track"><div class="ersb-fill" id="ersbFill"></div>' + puncte + '</div>' +
                    '<div class="ersb-labels">' + etichete + '</div>';
    bar.appendChild(box);
  }

  function deseneaza(total){
    var n = PRAGURI.length, seg = 100 / n;
    var pct = 100, urmator = -1, prag = 0;

    for(var i = 0; i < n; i++){
      if(total >= PRAGURI[i].bani){ prag = PRAGURI[i].bani; continue; }
      var frac = (total - prag) / (PRAGURI[i].bani - prag);
      frac = Math.max(0, Math.min(1, frac));
      pct = seg * i + seg * frac;
      urmator = i;
      break;
    }

    var fill = document.getElementById('ersbFill');
    if(fill){ fill.style.width = pct + '%'; }

    document.querySelectorAll('.ersb-dot').forEach(function(d){
      var i = parseInt(d.getAttribute('data-i'), 10);
      d.classList.toggle('is-on', total >= PRAGURI[i].bani);
    });

    var t = document.getElementById('ersbText');
    if(!t){ return; }
    if(urmator === -1){
      t.innerHTML = '<strong>Ai tot ce se putea debloca. Mulțumim!</strong>';
    } else {
      var lipsa = PRAGURI[urmator].bani - total;
      t.innerHTML = 'Mai adaugă <strong>' + lei(lipsa) + '</strong> pentru ' +
                    PRAGURI[urmator].eticheta.toLowerCase();
    }
  }

  var inCurs = false;
  function reciteste(){
    if(inCurs){ return; }
    inCurs = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ inCurs = false; deseneaza(c.total_price || 0); })
      .catch(function(){ inCurs = false; });
  }

  function boot(){
    var bar = document.getElementById('erShippingBar');

    /* Sertarul e randat de snippets/eramis-cart-drawer.liquid, iar noi rulam din
       sectiunea de anunt, care e mult mai sus in pagina. Daca dintr-un motiv oarecare
       bara nu e inca in DOM cand pornim, nu abandonam: asteptam sa apara. Asta era
       cauza cea mai probabila pentru care bara "nu mergea deloc". */
    if(!bar){
      if(!window.__ersbAstept && window.MutationObserver){
        window.__ersbAstept = true;
        var mo = new MutationObserver(function(){
          if(document.getElementById('erShippingBar')){ mo.disconnect(); window.__ersbAstept = false; boot(); }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
      }
      return;
    }
    if(bar.dataset.ersb === '1'){ return; }
    bar.dataset.ersb = '1';

    stiluri();
    schelet(bar);
    reciteste();

    /* Sertarul isi rescrie textul propriu la fiecare randare a cosului (deschidere,
       +/-, stergere, adaugare din recomandari). Il urmarim ca semnal. Nu atingem
       niciodata elementul asta, deci nu se poate face bucla. */
    var semnal = document.getElementById('erShippingText');
    if(semnal && window.MutationObserver){
      var t = null;
      new MutationObserver(function(){
        clearTimeout(t);
        t = setTimeout(reciteste, 60);
      }).observe(semnal, { childList: true, characterData: true, subtree: true });
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
